import { ErrorHandler, inject, Injectable, NgZone } from '@angular/core';
import { ToastService } from '@sentry/theme';
import { AppInsightsService } from '@sentry/forms-core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private zone = inject(NgZone);
  private appInsights = inject(AppInsightsService);
  private toast = inject(ToastService);

  handleError(error: unknown) {
    // Angular wraps errors thrown inside its zone — unwrap to get the real error and stack trace.
    const unwrapped = (error as any)?.ngOriginalError ?? error;

    const err =
      unwrapped instanceof Error
        ? unwrapped
        : new Error(
            typeof unwrapped === 'string'
              ? unwrapped
              : (JSON.stringify(unwrapped) ?? 'Unknown error')
          );

    // Lazy-loaded chunk failed to load (deploy while user is on the page) — reload to get fresh assets.
    if (/Loading chunk [\d]+ failed/.test(err.message)) {
      window.location.reload();
      return;
    }

    this.zone.run(() => {
      this.toast.error('There was an unexpected error. Please contact support.');
    });

    this.appInsights.trackException(err);
    console.error(error);
  }
}
